'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.failure = exports.askProvider = exports.spinner = exports.success = exports.notifyPushSent = exports.open = exports.close = exports.getImageDataURI = undefined;

var _qrImage = require('qr-image');

var _qrImage2 = _interopRequireDefault(_qrImage);

var _templates = require('./templates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module uport-transports/transport/ui
 * @description
 * A set of ui utility functions and default displays for bridging between
 * a web browser and a uport user's mobile app
 */

/**
 *  Given a string of data it returns a image URI which is a QR code. An image
 *  URI can be displayed in a img html tag by setting the src attrbiute to the
 *  the image URI.
 *
 *  @param    {String}     data      data string, typically a uPort URI
 *  @return   {String}               image URI
 */
var getImageDataURI = exports.getImageDataURI = function getImageDataURI(data) {
  var pngBuffer = _qrImage2.default.imageSync(data, { type: 'png' });
  return 'data:image/png;charset=utf-8;base64, ' + pngBuffer.toString('base64');
};

/**
 *  Closes the default QR pop over
 */
var close = exports.close = function close() {
  var uportWrapper = document.getElementById('uport-wrapper');
  if (uportWrapper) document.body.removeChild(uportWrapper);
};

/**
 * A utility function for rendering a modal with particular content
 *
 * @param     {String}    content   html string defining the inside of the modal
 * @param     {Function}  [close]   the handler to fire when the modal's x button is pressed
 */
var makeModal = function makeModal(content) {
  var closeModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : close;

  var wrapper = void 0;
  // Create new wrapper if not present
  if (!(wrapper = document.getElementById('uport-wrapper'))) {
    wrapper = document.createElement('div');
    wrapper.setAttribute('id', 'uport-wrapper');
  }

  wrapper.innerHTML = content;

  document.body.appendChild(wrapper);
  document.getElementById('uport__modal-x').addEventListener('click', closeModal);
};

/**
 *  A default QR pop over display, which injects the neccessary html
 *
 *  @param    {String}     data       data which is displayed in QR code
 *  @param    {Function}   cancel     a function called when the cancel button is clicked
 *  @param    {String}     modalText  message to be displayed above the QR in the modal
 */
var open = exports.open = function open(data, cancel, modalText) {
  var closeModal = close; // closure over close for use in callbacks etc.
  var content = (0, _templates.qrModal)(getImageDataURI(data), modalText);

  var cancelClick = function cancelClick(event) {
    document.getElementById('uport__qr-text').innerHTML = 'Cancelling';
    if (cancel) cancel();
    closeModal();
  };

  makeModal(content, cancelClick);
};

/**
 * Show a notification to the user that a push has been sent to their phone
 * @param   {Function}    fallback    The fallback handler if the user doesn't receive a push
 */
var notifyPushSent = exports.notifyPushSent = function notifyPushSent(fallback) {
  makeModal(_templates.pushModal);
  document.getElementById('uport__push-not-received').addEventListener('click', function () {
    close();
    fallback();
  });
};

/**
 * Show a success screen to the user which automatically dismisses
 * after @param {Number} timeout milliseconds
 */
var success = exports.success = function success() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;

  makeModal(_templates.successModal);
  setTimeout(close, timeout);
};

/**
 * Show a spinner (the Consensys Hurricane)
 * @param {Function} cancel  Function to fire when the close button is pressed
 */
var spinner = exports.spinner = function spinner() {
  var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : close;

  makeModal(_templates.spinnerModal, cancel);
};

/**
 * Present a dialog asking 
 */
var askProvider = exports.askProvider = function askProvider(isTx) {
  return new Promise(function (resolve, reject) {
    var closeAndResolve = function closeAndResolve(useInjectedProvider) {
      return function () {
        var remember = document.getElementById('uport__provider-remember').checked;
        close();
        resolve({ remember: remember, useInjectedProvider: useInjectedProvider });
      };
    };

    makeModal((0, _templates.providerModal)(isTx), closeAndResolve(false));

    // Set up event listeners on dialog buttons
    document.getElementById('uport__provider-yes').addEventListener('click', closeAndResolve(true));
    document.getElementById('uport__provider-no').addEventListener('click', closeAndResolve(false));
  });
};

/**
 * Show a failure modal that gives users the option to repeat the failed action
 * @param {Function}  resend  The function that should fire to allow the user to retry
 */
var failure = exports.failure = function failure(retry) {
  makeModal(_templates.failureModal);

  document.getElementById('uport__failure-retry').addEventListener('click', retry);
};


//////////////////
// WEBPACK FOOTER
// ./~/uport-transports/lib/transport/ui/index.js
// module id = 139
// module chunks = 0